const b2cJa = {
  ja: {
    myPlan: {
      title: '保有プラン状況',
      product_category: 'プランタイプ',
      product_name: 'プラン名',
      policy_status: '現状',
      policy_no: 'プラン番号',
    },
    myProfile: {
      title: 'お客様登録情報',
      name: 'お客様名',
      phone_number: '連絡先電話番号',
      email: 'Ｅメール',
      res_address: '現住所',
      corr_address: '通知先住所',
      for_company_only: '※以下の情報はアテナベストにて登録されている内容です',
      need_to_update_personal_info:
        '登録情報の変更を希望される場合には、アテナベストまたはお客様のサポート会社までご連絡をください',
    },
    messageBox: {
      title: 'メッセージボックス',
      subTitle: '対象プラン',
      type: '内容',
      policy_no: 'プラン番号',
    },
    planDetail: {
      title: '保有プラン状況',
      overview: 'プラン概要',
      details: '運用状況',
      form_download: 'ダウンロード',
      form_download_title: '書類名',
      form_download_link: 'リンク',
      form_download_original: '原本要',
      form_download_copy: 'コピー可',
      auto_translate_remark_1: '表示されるお客様の漢字氏名に誤りがある場合、自動翻訳機能が原因となります。',
      auto_translate_remark_2: '弊社での氏名登録はローマ字ですので、ブラウザの自動翻訳機能を解除のうえご確認ください。',
      assets_selection: 'アセット選択肢',
      assets_performance_information: 'アセット選択肢最新情報',
      hasl_announcement:
        'Heng An Standard Life社におけるシステム障害により、当社へのデータ提供が一時的に停止していることから、運用状況は最新の内容ではありません。最新の内容をお知りになりたい方は、個別にアテナベストまでお問合せください。',
    },
    statements: {
      monthly_statement: '運用状況報告書',
      provider_statement: 'Statement From',
      policy_owner: '名義人',
      address: '通知先住所', // statement always showing corr address
      contact_no: '連絡先電話番号',
      email: 'Ｅメール',
      print_out_date: '発行日',
      policy_no: 'プラン番号',
      plan_start_date: 'プラン開始日',
      plan_term: '契約年数',
      payment_freq: '支払頻度',
      pay_term: '積立期間',
      payment_method: '支払方法',
      policy_status: '現状',
      payment_status: 'お支払状況',
      portfolio_type: 'ポートフォリオタイプ',
      policy_plan_Name: '申込プラン名',
      joint_policy_Owner: '共同名義人',
      name_of_insured: '被保険者',
      name_of_beneficiary: '受益者',
      modal_premium: '支払金額',
      modal_premium_for_insurance: '積立金',
      total_premium_paid: '合計支払金額',
      estimated_premium_and_levy_amount: 'Estimated Premium & Levy Amount',
      next_contribute_due_date: '次回支払期日',
      pending_transaction_amount: '待機中取引金額',
      withdrawal_amount: '合計取崩金額',
      sum_insured: '保険金額',
      account_holder: 'プラン保有者',
      account_no: 'プラン番号',
      ac_opening_date: 'プラン開始日',
      account_type: 'プラン',
      joint_account_holder: '共同プラン保有者',
      report_currency: '運用報告書上の換算通貨',
      holding_type_I: '初期口座',
      holding_type_A: '貯蓄口座',
      holding_type_C: '保有ファンド',
      fund_code: 'ファンド コード', // FIXME: original need to add <br /> tag
      fund_name: 'ファンド名',
      unit_balance: 'ユニット数',
      fund_currency: 'ファンド 通貨', // FIXME: original need to add <br /> tag
      unit_price: 'ユニット 価格', // FIXME: original need to add <br /> tag
      valuation_date: '評価日',
      in_fund_currency: 'ファンド通貨換算',
      in_plan_currency: 'プラン通貨換算',
      sub_total: '小計',
      i_sub_total: '初期口座評価額小計',
      a_sub_total: '貯蓄口座評価額小計',
      total_portfolio_value: 'プラン評価額合計',
      total_portfolio_value_in_valuation_currency: '評価通貨換算',
      plan_type: '計劃種類',
      plan_name: '計畫名稱',
      total: '総額',
      available_balance: '合計金額',
      cash_balance: '保有キャッシュ',
      currency_type: '通貨タイプ',
      exch_rate: '為替レート',
      in_original_currency: '保有キャッシュの通貨',
      in_report_currency: '報告書上の換算通貨',
      contribution_allocation: '投資配分率％',
      portfolio_breakdown: '全体ポートフォリオ内容',
      allocation_percentage: '投資配分率％',
      portfolio_percentage: '投資配分率％',
      asset_class: '資産クラス',
      disclaimer_1:
        '上記ポートフォリオの時価総額および内容は、スウィッチング等により一部反映されていない場合があります。内容にご不明な点がありましたら{{companyName}}までご確認下さい。',
      disclaimer_2:
        'ファンド価格や株価、またそれらによる収益は上下するものです。過去のパフォーマンスが必ずしも将来に反映されるとは限りません。投資をされる前に、必ず説明書や案内書を読まれることを強くお勧めいたします。',
      disclaimer_3:
        '上記内容にご不明な点が確認された場合は、{{companyName}}までご連絡ください。',
      disclaimer_4:
        'この運用報告書は、使用されている為替レート同様、あくまでも参考資料としてご利用ください。お客様が実際に保有されているユニット数や最新の運用状況詳細については、商品プロバイダーより月毎/四半期毎/年毎に発行される明細書をご参照ください。',
      disclaimer_5:
        '{{companyName}}はポートフォリオマネジメントサービスに対するマネジメント費を、お客様の管理口座より直接ユニットにて自動引落としさせて頂きます。その他のお支払方法は受け付けておりませんので、何卒ご了承頂けます様お願い致します。',
      metis_disclaimer_1:
        '投資先に関する詳細はファンドファクトシートをご確認ください。',
      metis_disclaimer_2:
        'ファンド価格や株価は上下するものです。過去のパフォーマンスが必ずしも将来に反映されるとは限りません。投資をされる前に、必ず説明書や案内書を読まれることを強くお勧めいたします。',
      metis_disclaimer_3:
        'この運用報告書は、使用されている為替レート同様、あくまでも参考資料としてご利用ください。お客様が実際に保有されているユニット数や最新の運用状況詳細については、商品プロバイダーより発行される明細書をご参照ください。',
      metis_disclaimer_4:
        '上記内容にご不明な点が確認された場合は、アテナベストまでご連絡ください。',
      abf_fund_descriptions:
        'ABFストラテジックファンド - 組入上位10銘柄 (先月末時点）',
      abf_fund_allocation: 'ファンド内容',
      etf_fund_descriptions:
        'ETF システマチック トレーディング ファンド - 投資先の詳細（先月末時点）',
      etf_fund_allocation: 'ファンド内容',
    },
  },
};

export default b2cJa;
